import { DiscussionLinkPreview } from "./DiscussionLinkPreview";

interface DiscussionMediaDisplayProps {
  imageUrl?: string | null;
  linkUrl?: string | null;
  compact?: boolean;
}

export function DiscussionMediaDisplay({
  imageUrl,
  linkUrl,
  compact,
}: DiscussionMediaDisplayProps) {
  if (!imageUrl && !linkUrl) return null;

  return (
    <>
      {imageUrl && (
        compact ? (
          <img
            src={imageUrl}
            alt="Discussion attachment"
            className="h-16 w-16 object-cover rounded flex-shrink-0"
          />
        ) : (
          <img
            src={imageUrl}
            alt="Discussion attachment"
            className="mt-2 rounded-lg max-h-64 w-auto object-contain"
          />
        )
      )}
      {linkUrl && <DiscussionLinkPreview linkUrl={linkUrl} compact={compact} />}
    </>
  );
}
